import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'
import { ITrainingPersonRequirement } from '../../interfaces'

type QueryObject = { personId?: number }

const useTrainingPersonRequirementsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingPersonRequirement[] | undefined
>({
  getRequest: (_params, queryObject) => ({
    method: 'get',
    url: `${config.baseUrl}/PersonTrainingRequirements/person/${queryObject?.personId ?? ''}`,
    skip: !queryObject || !queryObject.personId, // Skip if personId is not provided
  }),
  getQueryKey: (_params, queryObject) => [
    'person-training-requirements',
    queryObject?.personId,
  ],
})

const useTrainingPersonRequirementsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingPersonRequirement[] | undefined, Error>,
) => useTrainingPersonRequirementsQueryBase(undefined, queryObject, options)

export default useTrainingPersonRequirementsQuery